import { defineComponent as I, ref as p, computed as i, watch as y, openBlock as s, createElementBlock as l, createElementVNode as n, createVNode as R, TransitionGroup as k, withCtx as C, Fragment as T, renderList as B, withDirectives as O, normalizeClass as S, createCommentVNode as f, vShow as w, createBlock as E, unref as M } from "vue";
import { Button as H } from "./button.es.js";
import './assets/index43.css';const D = { class: "RadioInputList__wrapper" }, V = {
  class: "RadioInputList",
  ref: "list"
}, N = { class: "RadioInputList__container" }, j = ["name", "checked", "onChange", "disabled"], z = /* @__PURE__ */ n("span", { class: "RadioInputList__checkmark" }, null, -1), F = ["innerHTML"], G = ["innerHTML"], J = /* @__PURE__ */ I({
  __name: "RadioInputList",
  props: {
    name: { default: "" },
    options: { default: () => [] },
    dataText: { default: "" },
    dataSubtext: { default: "" },
    value: { default: "" },
    isDisabled: { type: Boolean, default: !1 },
    hasError: { type: Boolean, default: !1 },
    maxOptions: { default: void 0 },
    resetExpand: { type: Boolean }
  },
  emits: ["change", "expand"],
  setup(_, { emit: u }) {
    const t = _, o = p(!1), h = p(!1), m = i(() => ({
      "RadioInputList--disabled": t.isDisabled === !0,
      "has-error": t.hasError === !0 || h.value === !0
    })), v = i(() => t.maxOptions !== void 0 && t.options.length > t.maxOptions && !o.value), x = i(() => t.value ? t.value : "");
    y(
      () => t.resetExpand,
      () => {
        o.value = !1;
      }
    );
    const L = (e) => t.maxOptions === void 0 || o.value ? !0 : e + 1 <= t.maxOptions, b = (e) => {
      u("change", { name: t.name, value: e });
    }, r = (e, d = !1) => {
      let a = "";
      return d && e && typeof e == "object" && t.dataSubtext.length > 0 ? a = e[t.dataSubtext] : e && typeof e == "object" && t.dataText.length > 0 ? a = e[t.dataText] : a = e, a.replace(/&nbsp;/gi, " ");
    }, g = () => {
      o.value = !0, u("expand");
    };
    return (e, d) => (s(), l("div", D, [
      n("div", V, [
        R(k, {
          name: "fade",
          tag: "span"
        }, {
          default: C(() => [
            (s(!0), l(T, null, B(e.options, (a, c) => O((s(), l("div", {
              class: S(["RadioInputList__item", m.value]),
              key: "RadioInputItem-" + c,
              ref_for: !0,
              ref: "radioButtonItem"
            }, [
              n("label", N, [
                n("input", {
                  type: "radio",
                  ref_for: !0,
                  ref: "inputField",
                  name: e.name,
                  checked: r(a) === x.value,
                  onChange: ($) => b(a),
                  disabled: e.isDisabled
                }, null, 40, j),
                z,
                n("div", null, [
                  n("span", {
                    class: "RadioInputList__label",
                    innerHTML: r(a)
                  }, null, 8, F),
                  e.dataSubtext.length > 0 ? (s(), l("span", {
                    key: 0,
                    class: "RadioInputList__subLabel",
                    innerHTML: r(a, !0)
                  }, null, 8, G)) : f("", !0)
                ])
              ])
            ], 2)), [
              [w, L(c)]
            ])), 128))
          ]),
          _: 1
        })
      ], 512),
      v.value ? (s(), E(M(H), {
        key: 0,
        text: "See more",
        icon: "ChevronRight",
        type: "Link",
        color: "Grey",
        size: "Medium",
        "is-loading": !1,
        "is-disabled": !1,
        onClick: g
      })) : f("", !0)
    ]));
  }
});
export {
  J as RadioInputList
};
